import {Component, OnInit} from "@angular/core";
import {AuthService} from "@auth0/auth0-angular";
import {Router} from "@angular/router";
import {filter, switchMap} from "rxjs";

@Component({
  standalone: true,
  selector: 'app-callback',
  template: `<p>Connexion en cours…</p>`
})
export class CallbackComponent implements OnInit {
  constructor(
    private router: Router,
    private auth: AuthService,
  ) { }

  ngOnInit(): void {
    this.auth.isAuthenticated$
      .pipe(
        filter(Boolean),
        switchMap(() => this.auth.appState$)
      )
      .subscribe((appState: any) => {
        this.router.navigateByUrl(appState?.target || '/profile');
      });
  }

}
